/*
The Emails tab's two sub-tabs: Campaigns (the template editor) and Sent (the
archive of sent emails, which used to be its own "Sent emails" tab).

The sub-tab lives in the query string (?view=sent) so a reload or a shared link
opens the same one. Tabs.jsx carries the query string to whichever tab you move
to; `view` is read by no other tab (Users/Subscriptions share email, name,
startDate, finishDate), so that is harmless.

CommonJS so the colocated test runs under plain node, like cmsTabs.js.
*/
const EMAILS_VIEWS = [
  { key: 'campaigns', label: 'Campaigns' },
  { key: 'sent', label: 'Sent' },
];

const DEFAULT_EMAILS_VIEW = 'campaigns';
const VIEW_PARAM = 'view';

const isEmailsView = key => EMAILS_VIEWS.some(view => view.key === key);

// '?view=sent&x=1' -> 'sent'; anything unknown or missing -> 'campaigns'.
const emailsViewFromSearch = (search) => {
  const value = new URLSearchParams(search || '').get(VIEW_PARAM);
  return isEmailsView(value) ? value : DEFAULT_EMAILS_VIEW;
};

// The query string for `view`, keeping every other parameter. The default view
// drops the parameter so the plain /cms/emails url stays clean.
const searchWithEmailsView = (search, view) => {
  const params = new URLSearchParams(search || '');
  if (!isEmailsView(view) || view === DEFAULT_EMAILS_VIEW) params.delete(VIEW_PARAM);
  else params.set(VIEW_PARAM, view);
  const next = params.toString();
  return next ? `?${next}` : '';
};

module.exports = {
  EMAILS_VIEWS,
  DEFAULT_EMAILS_VIEW,
  emailsViewFromSearch,
  searchWithEmailsView,
};
